// Where To Buy JavaScript for Locator

function SetPartnerType(n) {
    $("#ChannelPartner").val(n).trigger('change');
}
function SetProductType(n, i) {
    $("#ProductTypeID").val(n);
    $("#CategoryName").val(i);
    $('#wtbSearch').data('formValidation')
        .updateFieldStatus('productType', 'NotValidated')
        .validateField('productType');
}
function ClearProductType() {
    $("#ProductTypeID").val("");
    $("#CategoryName").val("");
    $("#BuyList").find('.in').removeClass('in');
    $("#ServiceList").find('.in').removeClass('in');
    $("#RentList").find('.in').removeClass('in');
    $("#BuyList").find('.active').removeClass('active');
    $("#ServiceList").find('.active').removeClass('active');
    $("#RentList").find('.active').removeClass('active');
}
function SetProductTypeName(n) {
    $("#ProductTypeName").val(n).trigger('change');
}

function DisplaySelectRetailer(show) {
    //if (show) {
    //    $("#findBuy").show();
    //    $('#wtbSearch').data('formValidation').enableValidator('findBuy');
    //} else {
    //    $("#findBuy").slideUp('fast');
    //    $("#find1").hide();
    //    $("#buy1").hide();
    //    $('#findBuy input[type="radio"]').prop("checked", false);
    //    $('#wtbSearch').data('formValidation').disableValidator('findBuy');
    //    $('#wtbSearch').data('formValidation').disableValidator('selectedRetailer');
    //    $('#findNow').show();
    //}
}
function DisplayLocatorTypes(wrbValue) {
    if (wrbValue == "Buy") {
        $("#BuyList").removeAttr("style");
        $("#ServiceList").attr("style", "display:none");
        $("#RentList").attr("style", "display:none");
    }
    if (wrbValue == "Service") {
        $("#ServiceList").removeAttr("style");
        $("#BuyList").attr("style", "display:none");
        $("#RentList").attr("style", "display:none");
    }
    if (wrbValue == "Rent") {
        $("#RentList").removeAttr("style");
        $("#ServiceList").attr("style", "display:none");
        $("#BuyList").attr("style", "display:none");
    }
}

function DisplayPostalCodeBuyOptions() {
    displayPostalCode = $("#country-selector option:selected").data("display-postal-code");
    if (displayPostalCode) {
        $("#postalCode").show();
        var selectedCountry = $("#country-selector option:selected").data("country-code");
        if (selectedCountry == "US" || selectedCountry == "CA")
        {
            $('#wtbSearch').data('formValidation').enableValidator('address');
            $('#wtbSearch').data('formValidation').enableValidator('postalCode');
            $("#address").show();
        }
        else {
            $('#wtbSearch').data('formValidation').enableValidator('postalCode');
            $('#wtbSearch').data('formValidation').disableValidator('address');
            $("#address").hide();
        }
       
    } else {
        $("#postalCode").hide();
        $("#address").hide();
        $('#wtbSearch').data('formValidation').disableValidator('postalCode');
        $('#wtbSearch').data('formValidation').disableValidator('address');
    }

    displayBuyOptions = $("#wtbSelect").children('option').length > 1;
    if (displayBuyOptions) {
        $("#buyOptions").show();
    } else if (displayBuyOptions == false) {
        $("#buyOptions").hide();
    }
}

$(document).ready(function () {
    if ($('#wtbSearch').length) {
        $('#wtbSearch')[0].reset();
        $(".template-ajax-loading").hide();
        var wrbValue = $("#searchDetails").find('#wtbSelect').find('option:selected').val();
        DisplayLocatorTypes(wrbValue);

        $('#wtbSearch').formValidation({
            plugins: {
                declarative: new FormValidation.plugins.Declarative()
            }
        });

        DisplayPostalCodeBuyOptions();

        $("#country-selector").on('change', function () {
            if ($("#country-selector").hasClass("disable-ajax")) {
                $("#zipCode").val('');
                DisplayPostalCodeBuyOptions();
                return true;
            }
            $(".template-ajax-loading").show();
           // $("#findBuy").hide();
            ClearProductType();
            DisplaySelectRetailer(false);
            var selectedCountry = $("#country-selector option:selected").data("country-code");
            $('#findNow').attr("class", "btn btn-primary disabled");
            $.getJSON("/Locator/GetSearchCriteria/?pCountry=" + selectedCountry, function (data) {
                var locatorTypes = data.LocatorTypes;
                $("#zipCode").val('');
                $('#wtbSearch').data('formValidation').resetForm();
                $("#wtbSelect option").remove();
                for (var i = 0; i < locatorTypes.length; i++) {
                    $("#wtbSelect").append("<option value='" + locatorTypes[i].Name + "'>" + locatorTypes[i].Name + "</option>");
                    var count = 1;
                    if (locatorTypes[i].Name == "Buy") {
                        var customerCategories = locatorTypes[i].CustomerCategories;
                        $("#BuyList").empty();
                        for (var j = 0; j < customerCategories.length; j++) {

                            var productTypes = customerCategories[j].ProductTypes;
							
                            var html = "<div class='panel panel-default' id='PanelDivBuy " + customerCategories[j].Name + "'>" +
                                        "<div class='panel-heading'>" +
                                                "<h4 class='panel-title hidden'>" + 
                                                "<a data-toggle='collapse' data-parent='#BuyList' href='#collapse" + count + "'>" + customerCategories[j].Name + "</a>" +
                                                "</h4>" +
                                        "</div>" +
                                        "<div id='collapse" + count + "'>" +
                                            "<div class='list-group'>";
                            var html1 = "";
                            for (var k = 0; k < productTypes.length; k++) {
                                var channelPartner = "";
                                switch (productTypes[k].ChannelPartner) {
                                    case 0:
                                        channelPartner = "Dealer";
                                        break;
                                    case 1:
                                        channelPartner = "Distributor";
                                        break;
                                    case 2:
                                        channelPartner = "AgricultureSalesManager";
                                        break;
                                    case 3:
                                        channelPartner = "DIYIrrigationRetailer";
                                        break;
                                }
                                html1 = html1 + "<a href='#' class='list-group-item list-group-item-action'  data-product-type-id='" + productTypes[k].ProductTypeId +
                                    "' title='" + productTypes[k].Name + "' data-result-type='" + channelPartner + "' data-category-name='" +
                                    customerCategories[j].Description + "' data-display-retailer='" + productTypes[k].DisplaySelectRetailer + "'>" + productTypes[k].Name + "</a>";
                            }
                            html1 += "</div>" +
                                    "</div>" +
                                "</div>";
                            $("#BuyList").append(html + html1);
                            count++;
                        }
                    }
                    count = 1;
                    if (locatorTypes[i].Name == "Service") {
                        var customerCategories = locatorTypes[i].CustomerCategories;
                        $("#ServiceList").empty();
                        for (var j = 0; j < customerCategories.length; j++) {

                            var productTypes = customerCategories[j].ProductTypes;

                            var html = "<div class='panel panel-default' id='PanelDivService " + customerCategories[j].Name + "'>" +
                                        "<div class='panel-heading'>" +
                                                    "<h4 class='panel-title'>" +
                                                        "<a data-toggle='collapse' data-parent='#SerrviceList' href='#panelService" + count + "'>" + customerCategories[j].Name + "</a>" +
                                                    "</h4>" +
                                        "</div>" +
                                        "<div id='panelService" + count + "' class='panel-collapse collapse'>" +
                                "<div class='list-group'>";
                            var html1 = "";
                            for (var k = 0; k < productTypes.length; k++) {
                                switch (productTypes[k].ChannelPartner) {
                                    case 0:
                                        channelPartner = "Dealer";
                                        break;
                                    case 1:
                                        channelPartner = "Distributor";
                                        break;
                                    case 2:
                                        channelPartner = "AgricultureSalesManager";
                                        break;
                                    case 3:
                                        channelPartner = "DIYIrrigationRetailer";
                                        break;
                                }
                                html1 = html1 + "<a href='#' class='list-group-item list-group-item-action' data-product-type-id='" + productTypes[k].ProductTypeId + "' title='" +
                                    productTypes[k].Name + " 'data-result-type='" + channelPartner + "' data-category-name='" + customerCategories[j].Description +
                                    "' data-display-retailer='" + productTypes[k].DisplaySelectRetailer + "'>" + productTypes[k].Name + "</a>";

                            }
                            html1 += "</div>" +
                                "</div>" +
                            "</div>";
                            $("#ServiceList").append(html + html1);
                            count++;
                        }
                    }
                    count = 1;
                    if (locatorTypes[i].Name == "Rent") {
                        var customerCategories = locatorTypes[i].CustomerCategories;
                        $("#RentList").empty();
                        for (var j = 0; j < customerCategories.length; j++) {

                            var productTypes = customerCategories[j].ProductTypes;

                            var html = "<div class='panel panel-default' id='PanelDivRent " + customerCategories[j].Name + "'>" +
                                        "<div class='panel-heading'>" +
                                                    "<h4 class='panel-title'>" +
                                                        "<a data-toggle='collapse' data-parent='#Rentist' href='#panelRent" + count + "' catName='" +
                                                            customerCategories[j].Name + "'>" + customerCategories[j].Name + "</a>" +
                                                    "</h4>" +
                                        "</div>" +
                                        "<div id='panelRent" + count + "' class='panel-collapse collapse'>" +
                            "<div class='list-group'>";
                            var html1 = "";
                            for (var k = 0; k < productTypes.length; k++) {
                                var channelPartner = "";
                                switch (productTypes[k].ChannelPartner) {
                                    case 0:
                                        channelPartner = "Dealer";
                                        break;
                                    case 1:
                                        channelPartner = "Distributor";
                                        break;
                                    case 2:
                                        channelPartner = "AgricultureSalesManager";
                                        break;
                                    case 3:
                                        channelPartner = "DIYIrrigationRetailer";
                                        break;
                                }
                                html1 = html1 + "<a href='#' class='list-group-item list-group-item-action' data-product-type-id='" + productTypes[k].ProductTypeId + "' title='" +
                                    productTypes[k].Name + " 'data-result-type='" + channelPartner + "' data-category-name='" + customerCategories[j].Description +
                                    "' data-display-retailer='" + productTypes[k].DisplaySelectRetailer + "'>" + productTypes[k].Name + "</a>";
                            }
                            html1 += "</div>" +
                                    "</div>" +
                                "</div>";
                            $("#RentList").append(html + html1);
                            count++;
                        }
                    }
                }
                DisplayPostalCodeBuyOptions();

            })
           .done(function () {
               $(".template-ajax-loading").hide();
               var wrbValue = $("#searchDetails").find('#wtbSelect').find('option:selected').val();
               DisplayLocatorTypes(wrbValue);
               $('#findNow').attr("class", "btn btn-primary");
               $('.list-group-item').on('click', function () {
                   var channelPartner = $(this).data("result-type");
                   var productID = $(this).data("product-type-id");
                   var customerCat = $(this).data("category-name");
                   var displayRetailer = $(this).data("display-retailer");
                   SetPartnerType(channelPartner);
                   SetProductType(productID, customerCat);
                   SetProductTypeName(productTypeName);
                   DisplaySelectRetailer(displayRetailer);
               });

           })
           .fail(function () { alert("An error has occurred!!!"); });
        });

        $('#wtbSelect').on('change', function () {
            ClearProductType();
            var wrbValue = $(this).find('option:selected').val();           
            DisplaySelectRetailer(false);
            DisplayLocatorTypes(wrbValue);
        });

        /* Toggle Collapse text */
        $(".changeText").click(function () {
            var defaultText = $(this).attr('data-text-default');
            var activeText = $(this).attr('data-text-active');
            if ($(this).is(".collapsed")) {
                $(this).text(activeText);
            } else {
                $(this).text(defaultText);
            }
        });

        /* WTB Panel Select */
        $('#wtbSearch .panel-select').on('click', '.list-group-item', function (e) {

            var previous = $(this).parents('.panel-select').find('.active');
            if ($(this).is(".active")) {

                $(this).removeClass('active');
                SetProductType('', '');
            } else {
                previous.removeClass('active');// previous list-item
                $(e.target).addClass('active'); // activated list-item			
            }
            e.preventDefault();
        });
        /* WTB findorBuy Toggle */
        $('#findorBuy input[type=radio]').on('change', function () {
            $('#find1 input[type="radio"], #buy1 input[type="radio"]').prop("checked", false);
            $('#find1,#buy1').hide();
            $('#wtbSearch').data('formValidation').enableValidator('selectedRetailer');

            if ($(this).is('#findorBuy1')) {
                $('#find1').show();
                $('#findNow').show();
                $('#wtbSearch').data('formValidation').enableValidator('selectedRetailer');
            } else {
                $('#buy1').show();
                $('#findNow').hide();
            }
        });
    }
});